module.exports = [{"link":"https://auth0.com/blog/cloud-identity-leader-auth0-adds-30-million-series-c/","title":"Auth0 raises $30M in Series C.","description":"New funds will accelerate platform growth and global company expansion.","cta":"Read More","iconColor":"#eb5424","probability":0.5},{"link":"http://auth0.com/jobs#job-openings","title":"We are hiring!","description":"If you care deeply about quality, teamwork, and want to build software that people love.","cta":"Join Us!","iconColor":"#eb5424","probability":0.5}]


//////////////////
// WEBPACK FOOTER
// ./src/data/featured-messages.json
// module id = 92
// module chunks = 0